import { __decorate } from "tslib";
import { attr, html, when, ref } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/mixin';
import { DEV } from 'esm-env';
export const iconBadgeTemplate = html `${when((x) => x.colorToken, () => html `<slot ${ref('content')} @slotchange="${(x) => x.handleContentChange()}"></slot>`)}`;
export class IconBadgeComponent extends ChameleonElementMixin(FoundationElement) {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.border = 'none';
        this.variant = 'primary';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAccessibleLabel();
    }
    labelChanged() {
        this.setAccessibleLabel();
    }
    colorTokenChanged(_, newValue) {
        if (newValue) {
            this.style.setProperty('--goto-badge-bg-color', `var(--${newValue})`);
        }
        else {
            this.style.setProperty('--goto-badge-bg-color', ``);
        }
    }
    handleContentChange() {
        this.content.assignedNodes()[0].style?.setProperty('--goto-icon-size', this.getIconSize(this.size));
    }
    getIconSize(size) {
        switch (size) {
            case 'small':
                return '16px';
            case 'xlarge':
                return '32px';
            default:
                return '24px';
        }
    }
    setAccessibleLabel() {
        if (this.label) {
            this.setAttribute('aria-label', this.label);
            return;
        }
        if (DEV) {
            this.validateAccessibleLabel();
        }
    }
    validateAccessibleLabel() {
        if (!this.getAttribute('aria-label')?.length) {
            console.error('CHAMELEON-A11Y: IconBadge component must have an accessible label provided by a non-empty label attribute to be used as aria-label.');
        }
    }
}
__decorate([
    attr
], IconBadgeComponent.prototype, "size", void 0);
__decorate([
    attr
], IconBadgeComponent.prototype, "border", void 0);
__decorate([
    attr()
], IconBadgeComponent.prototype, "variant", void 0);
__decorate([
    attr({ mode: 'boolean' })
], IconBadgeComponent.prototype, "disabled", void 0);
__decorate([
    attr({ attribute: 'color-token' })
], IconBadgeComponent.prototype, "colorToken", void 0);
__decorate([
    attr()
], IconBadgeComponent.prototype, "label", void 0);
